import { Box, CircularProgress, styled, Typography } from '@mui/material';
import { Column } from 'components/Layout';

const Centered = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  minHeight: 400,
});

const DarkCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[900],
}));

type Props = {
  title: string;
  subtitle?: string;
};

const ProcessingPage: React.FC<Props> = ({ title, subtitle }) => {
  return (
    <Centered>
      <Column spacing="lg" centered>
        <DarkCircularProgress size={40} />
        <Column spacing="xs" centered>
          <Typography variant="h4" align="center">
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" align="center">
              {subtitle}
            </Typography>
          ) : null}
        </Column>
      </Column>
    </Centered>
  );
};

export default ProcessingPage;
